// The company field is a combobox now (combobox.js) and submits the form itself.
// What is left is the rest of the filter reacting to a change - the combobox input
// excluded, because it restores the previous selection on blur and that would
// submit the form behind the user's back.
document.addEventListener('DOMContentLoaded', () => {
  const filterForm = document.querySelector('#filter-anaf-http-requests');

  if (!filterForm) return;

  const formElements = filterForm.querySelectorAll(
    'select, input[type="text"]:not([data-combobox-input]), input[type="date"]'
  );

  formElements.forEach((element) => {
    element.addEventListener('change', () => {
      filterForm.submit();
    });
  });
});
